<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">求職者へ追加の対応事項案内{{ inConfirm ? "（確認）" : "" }}</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <div class="dialog__body">
    <div class="content">
      <div class="content__table content__table--with-colon content__table--with-border">
        <div class="content__label content__label--with-colon">To (求職者)</div>
        <div class="content__value">{{ model?.to }}</div>

        <ng-container>
          <div class="content__label content__label--with-colon">CC (求職者)</div>
          <div class="content__value">{{ model.ccStudent }}</div>
        </ng-container>

        <ng-container>
          <div class="content__label content__label--with-colon">CC (求職者担当)</div>
          <div class="content__value">{{ model.ccCA }}</div>
        </ng-container>

        <ng-container>
          <div class="content__label content__label--with-colon">CC (RAアシ)</div>
          <div class="content__value">{{ model.ccRA }}</div>
        </ng-container>
      </div>

      <div *ngIf="!inConfirm && screeningInfo" class="content__requests">
        <ng-container *ngFor="let i of [1, 2, 3]">
          <div *ngIf="screeningInfo['request' + i]" class="content__table content__table--with-big-gap">
            <div class="content__label">対応事項{{ i }}</div>
            <div class="content__value request">
              <div class="request__part request__part--top">
                <div class="request__checkbox">
                  <input type="checkbox" [id]="'req' + i" [(ngModel)]="model['request' + i]" />
                  <label [for]="'req' + i">表示</label>
                </div>
                <div *ngIf="getDeadlineDisplay(screeningInfo['request' + i + 'Deadline']) as info" class="request__deadline-group">
                  <span class="request__deadline-label">対応期限：</span>
                  <input
                    *ngIf="info.isManual"
                    type="date"
                    [(ngModel)]="model['request' + i + 'DeadlineDate']"
                    class="request__date-input"
                    [class.request__date-input--error]="isDateInvalid(i)"
                  />
                  <span class="request__deadline-text">（{{ info.label }}）{{ info.subText }}</span>
                </div>
              </div>
              <div class="request__part request__part--bottom">{{ screeningInfo['request' + i] }}</div>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="inConfirm">
        <div class="content__table content__table--with-border">
          <div class="content__label">メール件名</div>
          <div class="content__value">{{ model?.subject }}</div>
        </div>
        <div class="content__table">
          <div class="content__label">メール本文</div>
          <div class="content__value content__value--pre">{{ model?.body }}</div>
        </div>
      </ng-container>

      <div *ngIf="!inConfirm" class="content__table content__message">
        <div class="content__label">連絡事項</div>
        <div class="content__value">
          <textarea class="content__textarea content__textarea--small" [(ngModel)]="message" (keydown.enter)="$event.stopPropagation()"></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog__footer">
    <ng-container *ngIf="!inConfirm; else confirmButtons">
      <button class="dialog__button dialog__button--accent" (click)="close()">キャンセル</button>
      <button class="dialog__button dialog__button--primary" [disabled]="isTemplateLoadInProgress || !isValidForConfirm()" (click)="getMailTemplate()">確認</button>
    </ng-container>
    <ng-template #confirmButtons>
      <button class="dialog__button dialog__button--warning-accent" (click)="inConfirm = false">戻る</button>
      <button class="dialog__button dialog__button--warning" [disabled]="isSendInProgress" (click)="send()">送信</button>
    </ng-template>
  </div>
</div>
